import Visit from '../components/templates/[visit-id]';

export const VisitContainer = () => {
  return <Visit />;
};
